import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import React, { useCallback } from "react";
var Tab = function(props) {
    var item = props.item, onTabClick = props.onTabClick, active = props.active;
    var onTabSelectedHandler = useCallback(function(item) {
        return function() {
            onTabClick(item);
        };
    }, [
        item
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: classnames("flex-none w-20 text-center font-bold py-2 text-sm rounded-xl cursor-pointer", {
            "bg-brandPrimary hover:bg-brandPrimaryHover text-tertiary": active
        }),
        "aria-hidden": "true",
        onClick: onTabSelectedHandler(item),
        children: item.text
    });
};
export default Tab;
